/**
 * Modal for delete confirmation (replaces window.confirm for clarity).
 */

import React from 'react';
import { createPortal } from 'react-dom';
import './DeleteConfirmModal.css';

export interface DeleteConfirmModalProps {
  isOpen: boolean;
  /** 本社から開いたか / 現場から開いたか（メッセージ文言用） */
  target: 'office' | 'construction';
  empCode: string;
  /** 本社・現場の両方に登録がある */
  dual: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  target,
  empCode,
  dual,
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  const isOffice = target === 'office';
  const sideLabel = isOffice ? '本社' : '現場';

  let message: string;
  if (dual) {
    message =
      '本社・現場の両方の登録を削除します。この操作は取り消せません。よろしいですか？';
  } else {
    message = `${sideLabel}の登録を削除します。この操作は取り消せません。よろしいですか？`;
  }

  return createPortal(
    <div
      className="delete-confirm-overlay"
      role="presentation"
      onClick={(e) => e.target === e.currentTarget && !isSubmitting && onClose()}
    >
      <div
        className="delete-confirm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-confirm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-confirm-header">
          <h3 id="delete-confirm-title">削除の確認</h3>
          <button
            type="button"
            className="delete-confirm-close"
            onClick={() => !isSubmitting && onClose()}
            disabled={isSubmitting}
            aria-label="閉じる"
          >
            ✕
          </button>
        </div>

        <div className="delete-confirm-body">
          <p className="delete-confirm-code">
            従業員コード: <strong>{empCode}</strong>
          </p>
          <p className="delete-confirm-message">{message}</p>
        </div>

        <div className="delete-confirm-actions">
          <button type="button" className="delete-confirm-btn cancel" onClick={onClose} disabled={isSubmitting}>
            いいえ
          </button>
          <button
            type="button"
            className="delete-confirm-btn danger"
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? '削除中…' : 'はい'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
